import styled from '@emotion/styled'

import { Spacing } from '../../enums/spacing'

interface AmountInfoBoxesGroupWrapperProps {
  itemsInRow: number
}

export const AmountInfoBoxesGroupWrapper = styled.ul<AmountInfoBoxesGroupWrapperProps>`
  display: grid;
  row-gap: ${Spacing.S16};
  column-gap: ${Spacing.S16};
  grid-template-columns: ${({ itemsInRow }) => `repeat(${itemsInRow}, 1fr)`};
  width: 100%;
  max-width: 100%;
`

export const AmountInfoBoxesGroupItem = styled.li`
  min-width: 0;
  overflow: hidden;
`
